import React from 'react'
import { useDispatch } from 'react-redux'
import { deleteIssue, getVolumes } from '../../../../entity/volumes/Volumes'
import { MdOutlineDelete } from 'react-icons/md'

const DeleteIssue = ({ issueId }) => {
  const dispatch = useDispatch()

  const deleteHandler = async () => {
    const confirmed = window.confirm('Do you want to delete this issue?')

    if (confirmed && issueId) {
      await dispatch(deleteIssue(issueId))
      dispatch(getVolumes())
    } else {
      console.log('Delete action canceled')
    }
  }
  return (
    <MdOutlineDelete
      className='hover:cursor-pointer hover:scale-110 transition-all'
      onClick={deleteHandler}
    />
  )
}

export default DeleteIssue
